import request from "root/js/request";

export const getAdvertTopBlockOzon = async ({
  wb_api_key_ids,
  date_from,
  date_to,
  group_by,
  reverse,
  ...rest
}) => {
  const response = await request({
    url: "/ozon_analytics/advert_top/",
    method: "get",
    params: {
      wb_api_key_ids,
      date_from,
      date_to,
      group_by,
      reverse,
      ...rest,
    },
  });
  return response.data;
};
